@use './variables' as *;

.container {
  color: $select-option-color;
  font-size: $select-option-font-size;
  font-family: $select-option-font-family;
  font-weight: $select-option-font-weight;
  line-height: $select-option-line-height;
  margin-top: $select-option-margin-top;
  margin-right: $select-option-margin-right;
  margin-bottom: $select-option-margin-bottom;
  margin-left: $select-option-margin-left;
  padding-top: $select-option-padding-top;
  padding-right: $select-option-padding-right;
  padding-bottom: $select-option-padding-bottom;
  padding-left: $select-option-padding-left;
  cursor: pointer;

  &:hover {
    color: $select-option-hover-color;
    background-color: $select-option-hover-background-color;
  }

  &.disabled {
    color: $select-option-disabled-color;
    background-color: $select-option-disabled-background-color;
  }
}

:host(:focus-visible) {
  .container {
    color: $select-option-hover-color;
    background-color: $select-option-hover-background-color;
  }
}
